/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Zone_NeuromuscularInputs */

const en_ui_zone_neuromuscular = /** @type {(inputs: Ui_Zone_NeuromuscularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuromuscular`)
};

const de_ui_zone_neuromuscular = /** @type {(inputs: Ui_Zone_NeuromuscularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuromuskulär`)
};

/**
* | output |
* | --- |
* | "Neuromuscular" |
*
* @param {Ui_Zone_NeuromuscularInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_zone_neuromuscular = /** @type {((inputs?: Ui_Zone_NeuromuscularInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Zone_NeuromuscularInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_zone_neuromuscular(inputs)
	return de_ui_zone_neuromuscular(inputs)
});